import React from "react";
import { useUser } from "../context/userContext";
import LoadingPage from "./LoadingPage";
// import CenteredMsg from './CenteredMsg';

// Accept children as props
type WrapperUserLoaderProps = {
  children: React.ReactNode;
};

const WrapperUserLoaderWithChildren: React.FC<WrapperUserLoaderProps> = ({ children }) => {
  const { status: userStatus } = useUser();

  if (userStatus === "loading" || userStatus === "fetchingSnapshot") {
    return <LoadingPage message="Loading user data..." />;
  }

  // if (userStatus === "failed") {
  //   return (
  //     <CenteredMsg
  //       message="Error"
  //       description="Failed to load user data. Please try again."
  //     />
  //   );
  // }

  // if (!userSnapshot || !userSnapshot.address) {
  //   return (
  //     <CenteredMsg
  //       message="No Profile Found"
  //       description="Please create a profile"
  //     />
  //   );
  // }

  return <>{children}</>;
};

export default WrapperUserLoaderWithChildren;
